import React from 'react';

import { OptionRows, type RowOption } from '@/components/services/wizard/field';
import { Card, CardContent } from '@/components/ui/card';
import { useThemeStore, type ThemePreference } from '@/store/themeStore';

const OPTIONS: RowOption<ThemePreference>[] = [
  { value: 'system', label: 'Igual ao aparelho', meaning: 'Muda sozinho quando o celular muda.' },
  { value: 'light', label: 'Claro' },
  { value: 'dark', label: 'Escuro' },
];

/** Perfil > Aparência: claro, escuro ou seguindo o aparelho. Vale só neste aparelho. */
export function AppearanceCard() {
  const preference = useThemeStore((state) => state.preference);
  const colorScheme = useThemeStore((state) => state.colorScheme);
  const setPreference = useThemeStore((state) => state.setPreference);

  return (
    <Card>
      <CardContent className="p-4">
        <OptionRows
          title="Aparência"
          note={
            preference === 'system'
              ? colorScheme === 'dark'
                ? 'Escuro agora'
                : 'Claro agora'
              : undefined
          }
          options={OPTIONS}
          value={preference}
          onChange={setPreference}
          testID="appearance"
        />
      </CardContent>
    </Card>
  );
}
